import { createFileRoute } from "@tanstack/react-router"

import { SavedPaymentMethodsRouteComponent } from "@/routes/_authenticated/account/saved-payment-methods/index"
import { savedPaymentMethodsOptions } from "@/utilities/hooks/queries/user"

export const Route = createFileRoute(
  "/qr/$qrLookupID/_authenticated/account/saved-payment-methods/"
)({
  beforeLoad: ({ context }) => {
    context.queryClient.fetchQuery(savedPaymentMethodsOptions())
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <SavedPaymentMethodsRouteComponent />
}
